export default __webpack_public_path__ + "static/media/skoly_img.77c712d5.png";